var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"my-6"},[_c('v-col',[_c('OfferForm')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }